import React, {ReactElement, ReactNode} from 'react';
import {cx} from '@emotion/css';
import {CheckedCircleIcon, CheckedIcon} from '@fo/root/designSystem/atoms/Icons';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import {fonts} from '@fo/shared/styles/variables';
import {IconColour} from './types';

import styles from './CheckpointItem.styles';

export {IconColour} from './types';

export enum Icon {
  TICKED_CIRCLE = 'CheckedCircleIcon',
  TICK = 'CheckedIcon',
}

interface Props {
  children?: ReactNode;
  className?: string;
  iconColour?: IconColour;
  icon: Icon;
  title?: string;
}

function CheckpointItem({children, className, iconColour, icon, title}: Props): ReactElement {
  const getIcon = () => {
    switch (icon) {
      case Icon.TICK:
        return CheckedIcon;
      case Icon.TICKED_CIRCLE:
      default:
        return CheckedCircleIcon;
    }
  };

  const IconComponent = getIcon();

  return (
    <div className={cx(styles.container, className)}>
      <IconComponent className={cx(styles.icon(iconColour))} />
      <div>
        {title && (
          <Headers className={cx(styles.title)} headerType={HeaderType.H4} alignment={fonts.alignment.LEFT}>
            {title}
          </Headers>
        )}
        <div className={cx(styles.content)}>{children}</div>
      </div>
    </div>
  );
}

export default CheckpointItem;
